import { Component, OnInit, OnDestroy,ViewChild,ElementRef,AfterViewInit } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './services/services';
import {AppService } from './app.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
import { MetaService } from 'ng2-meta';
import { CopyWriteService} from './services/copywrite.service';

interface GlobalData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  meta_keywords:string;
  logo:string;
  email:string;
  contactno:string;
  website:string;    
  pinterest_url:string;
  facebook_url:string;
  instagram_url:string;
  youtube_url:string;
  twitter_url:string;
  googleplus:string;
  address:string;
}

@Component({
    selector: 'my-app',
    templateUrl:'./pg/main/app.component.html',
    //template: require('./app.component.html'),
    //styles: [require('./app.component.scss')]
})
export class AppComponent {

   globaldata: GlobalData;
   private _sub: Subscription;
   public menulist:Array<any>;
   public footerlist1:Array<any>;
   public footerlist2:Array<any>;
   public siteurl;
   
   constructor(
	    
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private metaService: MetaService,
	    private copywriteservice: CopyWriteService,
	    private slimLoadingBarService: SlimLoadingBarService,
	    private _appService: AppService
	    ) {	    
		     this.siteurl=this.shareService.getSiteurl();
		     this.globaldata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: '',
                  meta_keywords:'',
                  logo:'',
                  email:'',
                  contactno:'' ,
                  googleplus:'',
                  twitter_url:'',
                  facebook_url:'',
                  pinterest_url:'',
                  instagram_url:'',
                  youtube_url:'',
                  website:'',
                  address:'',    
                              
				  	}

	    }
	    
	    ngOnInit() {
	    this.startLoading();
		this._sub = this._route.params.subscribe(params => {
			
			
			 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);			   
			   
			   this._appService.getMenu().subscribe(
        data => {
                  			  
				   this.copywriteservice.copywritelogo(data.copywrite);
				  
	
                 // this.ShareService.setetitle(data.siteinfo.meta_title);                  
                  this.globaldata.email=data.siteinfo.email;
                  
                  this.shareService.setcopywrite(data.copywrite);
                  this.shareService.setemail(this.globaldata.email);
                  this.shareService.setsiteinfo(this.globaldata);
                  
                  this.globaldata.contactno=data.siteinfo.mobileno;
                  this.globaldata.logo=data.siteinfo.logo;
                  this.globaldata.meta_title=data.siteinfo.meta_title;
                  this.globaldata.meta_description=data.siteinfo.meta_description;
                  this.globaldata.meta_keywords=data.siteinfo.meta_keywords;
                  this.globaldata.googleplus=data.siteinfo.google_map_url;
                  this.globaldata.youtube_url=data.siteinfo.youtube_url;
                  this.globaldata.instagram_url=data.siteinfo.instagram_url;
                  this.globaldata.twitter_url=data.siteinfo.twitter_url;
                  this.globaldata.facebook_url=data.siteinfo.facebook_url;
                  this.globaldata.pinterest_url=data.siteinfo.pinterest_url;
                  this.globaldata.website=data.siteinfo.website;
                  this.globaldata.address=data.siteinfo.site_address;
                  this.menulist=data.menu;
                  this.footerlist1=data.footer1;
                  this.footerlist2=data.footer2;
                  this.completeLoading();
                  
                  this.shareService.setetitle(data.siteinfo.meta_title);           
        },
        err => console.error(err),
        () => console.log('Main Service completed')
    );
			   
			   
			   
			   
			   
			   		   
		});
	}

    ngOnDestroy() {
       //this._sub.unsubscribe();
    }
    
    startLoading() {
        console.log('start Loading complete');
        this.slimLoadingBarService.start(() => {
            console.log('Loading complete');
        });
        
    
    }
    stopLoading() {
        this.slimLoadingBarService.stop();
    }
 
    completeLoading() {
        this.slimLoadingBarService.complete();
    }


}


// WEBPACK FOOTER //
// ./resources/assets/typescript/app.component.ts